import { render, staticRenderFns } from "./settingDoctor.vue?vue&type=template&id=28712e34&scoped=true&"
import script from "./settingDoctor.vue?vue&type=script&lang=js&"
export * from "./settingDoctor.vue?vue&type=script&lang=js&"
import style0 from "./settingDoctor.vue?vue&type=style&index=0&id=28712e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28712e34",
  null
  
)

export default component.exports